import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, ErrorHandler, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { AppInitializer } from './app-initializer';
import { CdkTableModule } from '@angular/cdk/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material-module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { APP_BASE_HREF, DatePipe } from '@angular/common';
// import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatIconModule } from '@angular/material/icon';
import { ErrorComponent } from './error/error.component';
import { CloseScrollStrategy, Overlay } from '@angular/cdk/overlay';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY } from '@angular/material/autocomplete';
import { environment } from 'src/environments/environment';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';

import { TranslateModule } from '@ngx-translate/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
export function init_app(appInit: AppInitializer) {
  return () => appInit.initializeApp();
}


export function scrollFactory(overlay: Overlay): () => CloseScrollStrategy {
  return () => overlay.scrollStrategies.close();
}


@NgModule({ declarations: [
        AppComponent,
        ErrorComponent
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    exports: [TranslateModule], imports: [BrowserModule,
        CoreModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        CdkTableModule,
        NgbModule,
        // NgxMatTimepickerModule,
        MatIconModule,
        ToastrModule.forRoot(),
        ScrollingModule,
        NgxSpinnerModule,
        TranslateModule], providers: [AppInitializer, DatePipe,
        {
            provide: APP_BASE_HREF,
            useValue: environment.app_base_href,
        },
        { provide: APP_INITIALIZER, useFactory: init_app, deps: [AppInitializer], multi: true },
        { provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY, useFactory: scrollFactory, deps: [Overlay] },
        {
            provide: MAT_DATE_LOCALE,
            deps: [AppInitializer],
            useFactory: (appInit: any) => appInit.defaultLocale()
        },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }] })
export class AppModule { }

